import { useaxios } from "../../../../utils/useaxios";
export default (radio_income_name, radio_income_amount, radio_income_date, radio_income_invoice, radio_income_note, radio_income_id) => setloading => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    setloading(true);
    useaxios('radio_income/update.php', { radio_income_name, radio_income_amount, radio_income_date, radio_income_invoice, radio_income_note, radio_income_id }).then((res) => {
        console.log(res);
        if (res.status == "ok") {
        } else {
            // clear();
        }
        setloading(false);
    });
}